// extracted by mini-css-extract-plugin
export default {"container":"FullPageGridLayout_container__beE7H"};